import * as InfoDeskActions from './info-desk.actions';

import {createReducer, on} from "@ngrx/store";
import {createEntityAdapter, EntityState} from "@ngrx/entity";
import {TenInfoDesk} from "../../_models/info-desk.models";
import {DahLoadingType} from '@common/components-module/core-components.models';
import {StoredComponentHelperService} from '@common/helpers/stored-component.helper.service';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const infoDeskFeatureKey = 'infoDesk';

export interface InfoDeskState extends EntityState<TenInfoDesk> {
    listLoading: DahLoadingType
}

export const infoDeskAdapter = createEntityAdapter<TenInfoDesk>({
    sortComparer: (a, b) => {
        if (a.sort > b.sort) {
            return -1;
        } else if (a.sort < b.sort) {
            return 1;
        } else {
            return 0;
        }
    }
});

export const initialState: InfoDeskState = infoDeskAdapter.getInitialState({
    listLoading: 'listLoading'
});

export const infoDeskReducer = createReducer(
    initialState,

    on(InfoDeskActions.loadList, (state) => ({
        ...state,
        listLoading: StoredComponentHelperService.updateListLoading({
            loading: state.listLoading,
            clearState: false
        }, state.ids)
    })),

    on(InfoDeskActions.loadListSuccess, (state, {items}) => infoDeskAdapter.setAll(
        items, {...state, listLoading: undefined}
    )),

    on(InfoDeskActions.loadListFailure, (state) => ({
        ...state,
        listLoading: undefined
    })),

    on(InfoDeskActions.deletedFromWS, (state, {itemId}) => infoDeskAdapter.removeOne(itemId, state)),

    on(InfoDeskActions.editedFromWS, (state, {item}) => infoDeskAdapter.setOne(item, state)),

    on(SetAllInitialStates, () => ({...initialState})),
);
